import { render, staticRenderFns } from "./BadgeOverall.vue?vue&type=template&id=8662c81e&scoped=true&"
import script from "./BadgeOverall.vue?vue&type=script&lang=js&"
export * from "./BadgeOverall.vue?vue&type=script&lang=js&"
import style0 from "./BadgeOverall.vue?vue&type=style&index=0&id=8662c81e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8662c81e",
  null
  
)

export default component.exports